<template>
  <div>
    <div class="hero-head-about">

      <div class="row">
        <div class="col s1 m1 l1 xl1"></div>
        <div class="col s12 m10 l4 xl4">

          <div class="claim-container">
            <div class="main-claim">
              <h1 class="style">
                <span style="color:white">{{ translation('Igotu.40') }}</span>
              </h1>
            </div>
            <div class="line"></div>
            <div class="secondary-claim">
              <h2 class="style">
                <span class="light">{{ translation('Igotu.41') }}</span>

              </h2>
            </div>

          </div>
        </div>
        <div class="col s12 m10 l4 xl4" style="text-align: center;">
          <div class="claim-container">

          <img src="@/assets/img/imgbig/about_slide.png" class="img-fluid img-device-about" alt="Igotu - Mobile Screen"
            title="Igotu - Mobile Screen" />

          </div>

        </div>
        <div class="col s1 m1 l1 xl1"></div>
      </div>
    </div>

    <div class="corpo-pagina margine-home">

      <div class="row margie-sup icon-row">
        <div class="col s1 m1 l1 xl1"></div>

        <div class="col s10 m10 l4 xl4">
          <img src="@/assets/img/imgbig/ipad-about.png" class="img-fluid img-device-about" alt="Ipad Screen"
            title="Ipad Screen" />
        </div>

        <div class="col s10 m10 l4 xl4">
          <h1 class="style color-black" v-html="this.highlightAndTranslate('Igotu.43.new.features')"></h1>
          <div class="line"></div>
          <br />
          <table class="ul-list-table">
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.43.qr.code') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.43.qr.code.fast.search') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.43.manage.rooms') }}</span></td>
            </tr>

            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('about.security.features') }}</span></td>
            </tr>

             <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('about.api.features') }}</span></td>
            </tr>
          </table>

          <br />

          <h1 class="style color-black" v-html="this.highlightAndTranslate('Igotu.42')"></h1>
          <div class="line"></div>
          <br />
          <table class="ul-list-table">
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.43') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('chekins') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.45') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.45.b') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.47') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.48') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.49') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.69') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.51') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.52') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.53') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.54') }}</span></td>
            </tr>
            <tr>
              <td class="td-list check"><i class="material-icons color-i">check</i></td>
              <td class="td-list"><span class="light">{{ translation('Igotu.55') }}</span></td>
            </tr>
          </table>
          <br /><br />

        </div>

        <div class="col s1 m1 l1 xl1"></div>
      </div>
    </div>

    <div class="hero-head-about card-section">

      <div class="row margie-sup icon-row">
        <div class="col s1 m1 l1 xl1"></div>
        <div class="col s10 m10 l10 xl10">
          <h1 class="style" style="color: white!important;">{{ translation('Igotu.56') }}</h1><br />
          <div class='line'></div>
        </div>
        <div class="col s1 m1 l1 xl1"></div>
      </div>

      <div class="row margie-sup icon-row">
        <div class="col s1 m1 l1 xl1"></div>

        <div class="col s12 m12 l3 xl3">
          <div class="card card-about">
            <strong>{{ translation('Igotu.57') }}</strong><br />
            <table class="ul-list-table">
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.58') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.59') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.60') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.61') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.57.mail') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.57.mail') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.57.tavoli') }}</span></td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col s12 m12 l3 xl3">
          <div class="card card-about">
            <strong>{{ translation('Igotu.62') }}</strong><br />
            <table class="ul-list-table">
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.63') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.64') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.64.b') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.65') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.66') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.67') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.68') }}</span></td>
              </tr>
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.69') }}</span></td>
              </tr>
            </table>
          </div>

        </div>

        <div class="col s12 m12 l3 xl3">
          <div class="card card-about">
            <strong>{{ translation('Igotu.70') }}</strong><br />
            <table class="ul-list-table">
              <tr>
                <td class="td-list check"><i class="material-icons color-i">check</i></td>
                <td class="td-list"><span class="light">{{ translation('Igotu.71') }}</span></td>
              </tr>
            </table>
          </div>

        </div>

        <div class="col s1 m1 l1 xl1"></div>
      </div>

    </div>

    <div class="row">
      <div class="col s1 m1 l1 xl1"></div>

      <div class="col s12 m12 l10 xl10" style="text-align: center!important;">
        <h1 class="style color-black">{{ translation('Igotu.72') }}</h1><br />
        <hr class="hr-class" />
        <span class="light disclaimer">{{ translation('Igotu.73') }}</span>
      </div>

      <div class="col s1 m1 l1 xl1"></div>
    </div>

    <div class="row">
      <div class="col s1 m1 l1 xl1"></div>

      <div class="col s12 m12 l5 xl5" style="margin-right: 22px!important">
        <table class="ul-list-table">
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.75') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.76') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.77') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('about.multilanguage.features') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.78') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.79') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.80') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.81') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.82') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.83') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/happy.png" class="list-icon" alt="Happy"
                title="Happy" /></td>
            <td class="td-list"><span class="light">{{ translation('Igotu.84') }}</span></td>
          </tr>
        </table>
      </div>

      <div class="col s12 m12 l5 xl5">
        <table class="ul-list-table">
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.86') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.87') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.88') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.89') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.90') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.91') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.92') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.93') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.94') }}</span></td>
          </tr>
          <tr>
            <td class="td-list check"><img src="@/assets/img/icons/sad.png" class="list-icon" alt="Sad" title="Sad" />
            </td>
            <td class="td-list"><span class="light">{{ translation('Igotu.95') }}</span></td>
          </tr>
        </table>

      </div>

      <div class="col s1 m1 l1 xl1"></div>
    </div>

    <div>
      <SignUpFree v-if="!isAuth" />

    </div>

  </div>

</template>

<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import SignUpFree from '@/components/SignUpFree.vue'
import useAuthStore from '@/store/authStore.js'

export default {
  name: 'app',
  data () {
    return {
      translationStore: translationStore,
      useAuthStore: useAuthStore
    }
  },
  components: {
    SignUpFree
  },

  computed: {
    translation () {
      return translationStore.getters.traduzione
    },
    isAuth () {
      return this.useAuthStore.getters.isAuthenticated
    }
  },
  methods: {

    highlightAndTranslate (key) {
      const translatedText = this.translation(key)
      const regex = /^(\S+)/
      const replacementString = '<span class="light">$1</span>'
      return translatedText.replace(regex, replacementString)
    }
  },

  async mounted () {
    loadingStore.commit('setLoading', false)
  },

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>

<style>
.hero-head-about {
  background-color: #2c2f2e;
}

.img-device-about {
  width: 100% !important;
}

h1.style.color-black {
  color: black !important;
  font-size: 1.5em;
}

.hr-class {
  border: 3px solid #c42634;
  width: 30%;
  margin: 20px auto;
  border-radius: 1px;
}

.color-i {
  color: #a0b800;
  font-size: 20px;
}

.list-icon {
  width: 20px;
  height: auto;
}

.text-align-center {
  text-align: center !important;
}

.card-about {
  min-height: 350px !important;
  padding: 20px !important;
  margin-left: 10px;
}

.disclaimer {
  color: #a9a9a9;
}

/* ------------------------------------ */
/* 2. MEDIA QUERY - TABLET (Max 992px) */
/* ------------------------------------ */
@media screen and (max-width: 992px) {
  .claim-container {
    padding-left: 1%;
    padding-right: 1%;

}
.card-about{
  margin: 0px!important;
}

}

/* ------------------------------------ */
/* 3. MEDIA QUERY - MOBILE (Max 600px) */
/* ------------------------------------ */
@media screen and (max-width: 600px) {
  .claim-container {
    padding-left: 1%;
    padding-right: 1%;

}
.card-about{
  margin: 0px!important;
}

}
</style>
